<template>
  <label class="custom-toggle" :class="[switchClass, { 'custom-toggle-disabled': disabled }]">
    <input v-model="model" type="checkbox" :disabled="disabled" />
    <span class="custom-toggle-slider rounded-circle" :data-label-off="offText" :data-label-on="onText"> </span>
  </label>
</template>
<script>
export default {
  name: 'BaseSwitch',
  props: {
    value: [Array, Boolean],
    type: String,
    onText: {
      type: String,
      default: 'Yes',
    },
    offText: {
      type: String,
      default: 'No',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    switchClass() {
      let baseClass = 'custom-toggle-';
      if (this.type) {
        return baseClass + this.type;
      }
      return '';
    },
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    triggerToggle() {
      this.model = !this.model;
    },
    click() {},
  },
};
</script>
<style>
.custom-toggle-disabled {
  cursor: not-allowed;
}
.custom-toggle-disabled input:disabled + .custom-toggle-slider {
  cursor: not-allowed;
}
</style>
